<script lang="ts">
    import { getStoresContext } from "~/stores";
    import type { StoresKey } from "~/stores";
    import DropDown from "../stores/DropDown.svelte";
    import Button from "../Button.svelte";
    import { L10nService } from "~/service/l10n";
    export let request_store_key: StoresKey;
    const stores_context = getStoresContext(request_store_key);
    const { i18nOf, alternate, locale, nav_menus, reverse_router, site } = stores_context; 

    $: studentHousingMenu = $nav_menus.find(x => x.name == 'Student housing');
    $: studentHousingNavMenuItems = studentHousingMenu?.navigationMenuItems || [];

    $: showDropdown = false;

    $: alternate_locale = ['sv-SE', 'en-US'].find(x => x != $locale) || 'sv-SE';
    $: alternate_href = $alternate.find(x => x.locale = alternate_locale);
    $: alternate_trans = L10nService.getTranslator($site.theme.key, alternate_locale);
    $: alternate_lang = alternate_trans('language');
  </script>
    
  <div class="mt-6 mb-md-0 mb-4">
    <div class="row">
      {#each studentHousingNavMenuItems as menu}
        <div class="col-xl-2 col-lg-3 col-md-4 col-12">
          <DropDown {showDropdown}>
            <svelte:fragment slot="default-value">
              {i18nOf(menu.name_i18n)}
            </svelte:fragment>
            <svelte:fragment slot="options">
              {#each menu.navigationMenuItems as submenu}
                <a
                  class="option"
                  href={$reverse_router.routePage(submenu.link)}>
                  {i18nOf(submenu.name_i18n)}
                </a>
              {/each}
            </svelte:fragment>
          </DropDown>
        </div>
      {/each}
      <div class="col-xl-2 col-lg-2 col-md-4 col-6">
        <Button href={alternate_href?.href} type="secondary">{alternate_lang}</Button>
      </div>
    </div>
  </div>

  <style lang="scss">
    .option {
      display: block;
      background-color: var(--color-white);
      width: 100%;
      border: none;
      padding: 0.25rem 0.5rem;
      text-align: left;
      font-size: 18px;
      color: var(--color-black);
    }
    .option:hover {
      background-color: var(--color-black);
      color: var(--color-white);
      text-decoration: none;
    }
  </style>